import EmployerCandidates from '../views/EmployerBase/EmployerCandidates';
import EmployerJobs from '../views/EmployerBase/EmployerJobs';

const url_prefix = process.env.VUE_APP_URL_PREFIX;

export default [
  {
    path: '/employer/candidates',
    name: 'employer_candidates',
    component: EmployerCandidates,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      breadcrumb: function() {
        return 'Employer Candidates';
      },
    },
  },
  {
    path: '/employer/jobs',
    name: 'employer_jobs',
    component: EmployerJobs,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      breadcrumb: function() {
        return 'Employer Jobs';
      },
    },
  },
];
